import React from 'react';

const Footer = () => (
  <footer className="footer">
    <img src={`${process.env.PUBLIC_URL}/mark-logo.png`} alt="Manzili Smart" style={{ height: 24, verticalAlign: 'middle' }} />
    <span>© {new Date().getFullYear()} Manzili Smart — EPO Power and Control Trading</span>
  </footer>
);

export default Footer;
